import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function EditReservationDialog({ open, onClose, reservation, authAxios, onRefresh }) {
  const handleSaveEdit = async () => {
    if (!reservation) return;
    try {
      const { id, ...data } = reservation;
      await authAxios.patch(`/reservations/${id}`, data);
      toast.success("Reserva guardada");
      onClose();
      onRefresh();
    } catch { toast.error("Erro ao guardar"); }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="w-[95vw] max-w-md max-h-[90dvh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Editar Reserva</DialogTitle>
        </DialogHeader>
        {reservation && (
          <div className="space-y-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div>
                <Label className="text-xs">Nome</Label>
                <Input value={reservation.customer_name} onChange={e => reservation.customer_name = e.target.value} />
              </div>
              <div>
                <Label className="text-xs">Telefone</Label>
                <Input value={reservation.customer_phone} onChange={e => reservation.customer_phone = e.target.value} />
              </div>
            </div>
            <div>
              <Label className="text-xs">Email</Label>
              <Input value={reservation.customer_email || ""} onChange={e => reservation.customer_email = e.target.value} />
            </div>
            <div className="grid grid-cols-3 gap-2 sm:gap-3">
              <div>
                <Label className="text-xs">Data</Label>
                <Input type="date" value={reservation.date} onChange={e => reservation.date = e.target.value} />
              </div>
              <div>
                <Label className="text-xs">Hora</Label>
                <Input type="time" value={reservation.time} onChange={e => reservation.time = e.target.value} />
              </div>
              <div>
                <Label className="text-xs">Pessoas</Label>
                <Input type="number" value={reservation.guests} onChange={e => reservation.guests = Number(e.target.value)} />
              </div>
            </div>
            <div>
              <Label className="text-xs">Localização</Label>
              <Select value={reservation.seating_preference || "sin_preferencia"} onValueChange={v => reservation.seating_preference = v}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="sin_preferencia">Sem preferência</SelectItem>
                  <SelectItem value="interior">Interior</SelectItem>
                  <SelectItem value="exterior">Exterior/Esplanada</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs">Estado</Label>
              <Select value={reservation.status} onValueChange={v => reservation.status = v}>
                <SelectTrigger><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="pending">Pendente</SelectItem>
                  <SelectItem value="confirmed">Confirmada</SelectItem>
                  <SelectItem value="cancelled">Cancelada</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-xs">Notas do cliente</Label>
              <Textarea value={reservation.notes || ""} onChange={e => reservation.notes = e.target.value} rows={2} />
            </div>
            <div>
              <Label className="text-xs">Notas internas (admin)</Label>
              <Textarea value={reservation.admin_notes || ""} onChange={e => reservation.admin_notes = e.target.value} rows={2} placeholder="Visível só para a equipa" />
            </div>
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={handleSaveEdit} className="bg-emerald-600 hover:bg-emerald-700 text-white">Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
